export default __webpack_public_path__ + "static/media/999.3f44a1ef.gif";